import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {HealthService} from "../../../services/tools/health.service";
import {ServiceHealthState} from "../../../model/tools/service-health-state";
import {CcBaseComponent} from "../../../crystal-elements/cc-base.component";
import {AppConfigService} from "../../../services/app-config.service";
import TYPE = ServiceHealthState.TYPE;
import {EMPTY, exhaustMap, Observable, take, takeUntil, timer} from "rxjs";
import {catchError, filter} from "rxjs/operators";

@Component({
  selector: 'app-services-health',
  templateUrl: './health.component.html',
  styleUrls: ['./health.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HealthComponent extends CcBaseComponent {

  serviceHealthStatutes: ServiceHealthState[] = [];

  hubRunning: boolean = true;
  archiveRunning: boolean = true;
  someGatewaysRunning: boolean = true;
  allGatewaysRunning: boolean = true;
  runningGateways: string = '';
  notRunningGateways: string = '';
  loading: boolean = true;
  @Input()
  modeLarge: boolean = false;
  @Input()
  autoReload: boolean = true;
  detailOpen: boolean = false;
  lockedDetailOpen: boolean = false;
  enabled = true;

  private healthLoopSub?: any;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              private healthService: HealthService,
              private appConfigService: AppConfigService) {
    super(cdref, messageService, translateService);
  }

  protected initData() {
    super.initData();
    this.loading = true
    // if (this.enabled)
    this.startHealthServicesLoop();
  }

  ngOnInit() {
    super.ngOnInit();
    // if (this.isAdmin()) {
    //   this.enabled = this.appConfigService.healthEnabledForAdmin;
    // } else {
    //   this.enabled = this.appConfigService.healthEnabled;
    // }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  startHealthServicesLoop(): void {
    const intervalMs = this.appConfigService.healthCheckInterval;

    this.healthLoopSub?.unsubscribe();

    let tick$: Observable<number> = timer(0, intervalMs).pipe(takeUntil(this.destroy$));

    // autoReload=true => poll forever
    // autoReload=false => call once
    if (!this.autoReload) {
      tick$ = tick$.pipe(take(1));
    }

    this.healthLoopSub = tick$
      .pipe(
        exhaustMap(() =>
          this.healthService.getServicesHealth().pipe(
            catchError(err => {
              this.errorMessage(String(err));
              this.loading = false;
              this.markForCheck();
              return EMPTY;
            }),
          ),
        ),
      )
      .subscribe(apiValidation => {
        if (!apiValidation.success) return;

        this.serviceHealthStatutes = apiValidation.item;

        let state = this.serviceHealthStatutes.find(s => s.type === TYPE.HUB);
        this.hubRunning = state ? state.running : false;

        state = this.serviceHealthStatutes.find(s => s.type === TYPE.ARCHIVE);
        this.archiveRunning = state ? state.running : false;

        this.someGatewaysRunning = false;
        this.allGatewaysRunning = true;

        const running: string[] = [];
        const notRunning: string[] = [];

        this.serviceHealthStatutes.forEach(s => {
          if (s.type === TYPE.GATEWAY) {
            if (!s.running) {
              notRunning.push(s.serviceName);
              this.allGatewaysRunning = false;
            } else {
              running.push(s.serviceName);
              this.someGatewaysRunning = true;
            }
          }
        });

        if (this.allGatewaysRunning) this.someGatewaysRunning = true;

        this.runningGateways = running.join(',');
        this.notRunningGateways = notRunning.join(',');

        this.loading = false;
        this.markForCheck();
      });
  }
}
